import React from "react";
import CustomDateFilter from "../dateFilter/customDateFilter";
import { SearchComponent } from "../searchComponent/searchComponent";

// Use the same date and location layout across marketing reports.
export const ReportFilterSection = ({
  dateState,
  setDateState,
  isTodayExcluded = false,
  testId,
  children,
}) => (
  <div className="d-flex flex-lg-row flex-column justify-content-between">
    <CustomDateFilter
      dateState={dateState}
      setDateState={setDateState}
      isTodayExcluded={isTodayExcluded}
    />
    <div className="d-flex flex-sm-row flex-column justify-content-between" data-testid={testId}>
      {children}
    </div>
  </div>
);

// Keep campaign table headings and search controls consistent.
export const ReportTableSection = ({
  title,
  searchString,
  setSearchString,
  children,
}) => (
  <div className="mt-3 bg-white shadow rounded">
    <div className="d-flex justify-content-between">
      <h5 className="px-4 pt-4">{title}</h5>
      <SearchComponent
        searchString={searchString}
        setSearchString={setSearchString}
        containerClass="mx-4 mb-2 pt-3 w20"
      />
    </div>
    <hr className="mx-4" />
    {children}
  </div>
);
